import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App, { AppContextProvider } from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppContextProvider>
      <App />
    </AppContextProvider>
  </React.StrictMode>
);
